import { render } from "./ParcelaSorte.vue?vue&type=template&id=aac16c34"
import script from "./ParcelaSorte.vue?vue&type=script&lang=js"
export * from "./ParcelaSorte.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__